import { Box, Card } from '@material-ui/core'
import React, { useState, useRef, useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { useServices } from 'cng-web-lib'
import pathMap from '../../../paths/pathMap'
import NbciUsInvoiceApiUrls from '../../../apiUrls/NbciUsInvoiceApiUrls'
import withFormState from '../../../components/aciacehighway/hocs/withFormState'
import Stepper from '../../../components/aciacehighway/Stepper'
import InvoiceEditForm from './InvoiceEditForm'
import InvoiceDetailsAndSummaryInvoiceSection from './InvoiceDetailsAndSummaryInvoiceSection'
import ResponseLogAndHistorySection from './ResponseLogAndHistorySection'
import AlertDialog from '../../../components/aciacehighway/AlertDialog'
import { FileForUserGetPartyId, FileForUserGetUserDetails } from 'src/common/FileForUserCommon'

function EditPage(props) {
  const { history, onSetLoading, showNotification, location } = props
  const { state } = location
  const [step, setStep] = useState(state?.step ? state.step : 0)
  const [alertDialog, setAlertDialog] = useState(false)
  const [submitAlertDialog, setSubmitAlertDialog] = useState(false)
  const { id } = useParams()
  const invoiceData = useRef(state?.invoiceData)
  const { securedSendRequest } = useServices()

  const [invoiceIsDirty, setInvoiceIsDirty] = useState(false)
  const isPendingSave = useRef(false)
  const isPendingSaveShipmentSummary = useRef(false)
  const isNotSaved = useRef(false)

  const memoedInvoiceDetailsAndSummaryInvoiceSection = useMemo(() => (
    <InvoiceDetailsAndSummaryInvoiceSection
      invoiceData={invoiceData}
      onBack={() => preSetStep((step) => step - 1)}
      onDiscard={setStep}
      // onSetInvoiceData={setInvoiceData}
      onSetLoading={onSetLoading}
      onSkip={() => preSetStep((step) => step + 1)}
      onSubmit={preSubmit}
      showNotification={showNotification}
      isPendingSave={isPendingSave}
      isPendingSaveShipmentSummary={isPendingSaveShipmentSummary}
      isNotSaved={isNotSaved}
    />
  ), [invoiceData.current])

  function preSetStep(step) {
    if (isNotSaved.current || isPendingSave.current || isPendingSaveShipmentSummary.current || invoiceIsDirty) {
      alert("Changes have not been saved. Please save the changes before proceed.")
    } else {
      return setStep(step)
    }
  }

  function renderContent() {
    switch (step) {
      case 0:
        return (
          <InvoiceEditForm
            history={history}
            id={id}
            invoiceData={invoiceData}
            // onDiscard={() => setAlertDialog(true)}
            onSaveProceedNextStep={() => setStep((step) => step + 1)}
            onProceedNextStep={() => preSetStep((step) => step + 1)}
            // onSetInvoiceData={setInvoiceData}
            onSetLoading={onSetLoading}
            showNotification={showNotification}
            invoiceIsDirty={invoiceIsDirty}
            setInvoiceIsDirty={setInvoiceIsDirty}
          />
        )
      case 1:
        return (
          memoedInvoiceDetailsAndSummaryInvoiceSection
        )
      case 2:
        return (
          <ResponseLogAndHistorySection
            id={id}
            onBack={() => setStep((step) => step - 1)}
            onDiscard={() => setAlertDialog(true)}
            onSubmit={preSubmit}
          />
        )
    }
  }

  function preSubmit() {
    if (isPendingSave.current || isPendingSaveShipmentSummary.current) {
      setSubmitAlertDialog(true)
    } else {
      handleSubmit()
    }
  }

  function handleSubmit() {
    setSubmitAlertDialog(false)
    onSetLoading(true)
    let invData = invoiceData.current
    let fileForUserDetails = FileForUserGetUserDetails();
    if (fileForUserDetails != null && fileForUserDetails != undefined) {
      invData.fileForUserId = fileForUserDetails.fileForUserId;
      invData.fileForUserLoginId = fileForUserDetails.fileForUserLoginId;
      invData.fileForUserPartyId = fileForUserDetails.fileForUserPartyId;
    }

    securedSendRequest.execute(
      'POST',
      NbciUsInvoiceApiUrls.SUBMIT,
      invData,
      (response) => {
        var data = response.data
        var errorMessages = data.errorMessages

        if (response.status == 200 && data != null && errorMessages == null) {
          showNotification('success', 'Submit successfully')
          history.push(pathMap.NBCI_US_INVOICE_LIST_VIEW)
        } else {
          showNotification('error', errorMessages)
        }
      },
      (error) => console.error(error),
      () => onSetLoading(false)
    )
  }

  return (
    <>
      <Card>
        <Stepper
          steps={[
            'Provide details',
            'Add invoice lines & summary invoice',
            'View logs & history'
          ]}
          activeStep={step}
          onSetActiveStep={(step) => preSetStep(step)}
        />
        <Box padding={2}>{renderContent()}</Box>
      </Card>
      <AlertDialog
        cancelLabel='Continue editing'
        confirmLabel='Yes, discard'
        open={alertDialog}
        onClose={() => setAlertDialog(false)}
        onCancel={() => setAlertDialog(false)}
        onConfirm={() => history.push(pathMap.NBCI_US_INVOICE_LIST_VIEW)}
        title='Discard'
      >
        All progress in this session will be lost and can't be restored. Are you
        sure about this?
      </AlertDialog>
      <AlertDialog
        cancelLabel='Continue editing'
        confirmLabel='Yes, submit'
        open={submitAlertDialog}
        onClose={() => setSubmitAlertDialog(false)}
        onCancel={() => setSubmitAlertDialog(false)}
        onConfirm={() => handleSubmit()}
        title='Alert'
      >
        Changes have not been saved. Do you want to proceed without saving?
      </AlertDialog>
    </>
  )
}

export default withFormState(EditPage)
